import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "projects",
  "use": "projects-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"projects\">\n<rect x=\"1\" y=\"1\" width=\"6.29998\" height=\"4.89998\" rx=\"1.75\" />\n<rect x=\"8.7002\" y=\"1\" width=\"6.29998\" height=\"7.69997\" rx=\"1.75\" />\n<rect x=\"1\" y=\"7.29932\" width=\"6.29998\" height=\"7.69997\" rx=\"1.75\" />\n<rect x=\"8.7002\" y=\"10.1006\" width=\"6.29998\" height=\"4.89998\" rx=\"1.75\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol